import { AccountType } from '../enums';

export const AccountTypes = [
  { name: 'Person', value: AccountType.Person },
];
